import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function TopBar() {
  // TODO: replace with company name from cms edge cache
  const companyName = 'Company name';
  return /*#__PURE__*/_jsxs(Flex, {
    backgroundColor: "fill-surface-default",
    justifyContent: "space-between",
    alignItems: "center",
    paddingInline: "1100",
    paddingBlock: "500",
    borderBlockEndStyle: "solid",
    borderBlockEndColor: "border-transitional-core-subtle",
    borderBlockEndWidth: "100",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-300",
      children: companyName
    }), /*#__PURE__*/_jsx(Link, {
      href: "/signout",
      use: "unstyled",
      typography: "body-125",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.signOut"
      })
    })]
  });
}